import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';

import { ChangepasswordComponent } from '../useraccess/changepassword/changepassword.component';
import { ComponentheaderService } from './componentheader.service';
import { SchoolmanagementService } from './schoolmanagement.service';
import { DatePipe } from '@angular/common';
import { SchoolConfig, SchoolInfoBundle } from '../models/school/schooladminitem.model';
import { ToastrService } from 'ngx-toastr';
import { Device } from '../models/devicetype';
//import { AccountFeature } from '../models/billing/BillingAccountInfo';

declare var $: any;

@Injectable({
  providedIn: 'root'
})
export class UtilService {

  rootUrl = environment.ImpataAppAPIRoot;
  userSubDomainAdminStatus = false;
  confirmPromise: Promise<boolean>;
  dialogConfirmMode: boolean = true;
  confirmPromiseResolve: (value: boolean | PromiseLike<boolean>) => void;
  public schoolInfoBundle: SchoolInfoBundle = new SchoolInfoBundle();
  schoolInfoBundlePromise: Promise<SchoolInfoBundle> = null;

  constructor(private http:HttpClient,private datePipe: DatePipe, private toastr: ToastrService) {

  }

  reFormatNGorUKPhoneNumber(stringNumber: string, countryCode: string): string{
    let startsWithZero = stringNumber[0] == '0';
    if(startsWithZero && stringNumber.length == 11 && (countryCode === '+234' || countryCode === '+44')){
      stringNumber = stringNumber.substring(1);
    }
    return stringNumber;
  }

  getPhoneNumberRegexPattern(value, firstDigit){    
    let phoneNumberPattern;
    switch (value){
      case '+234': case '+44':
        firstDigit == '0' ? phoneNumberPattern = /^[0-9]{11}$/ : phoneNumberPattern = /^[0-9]{10}$/;
        break;
      case '+1':
        phoneNumberPattern = /^[0-9]{10}$/;
        break;
      default:
        phoneNumberPattern = /^[0-9]+$/;
        break;
    }
    return phoneNumberPattern;
  }
  getNewSubdomainUrl(newsubdomain, userToken){
    const location = window.location.hostname;
      const splitlocation = location.split('.');
      //let splitdomainlocation: string[];
      let subdomain = "";
      let domain = '';
      if(splitlocation.length >= 2){
        subdomain = splitlocation[0];
      }
      else{
          subdomain = '';
      }
      if(subdomain){
        splitlocation.splice(0, 1);
        domain = splitlocation.join('.');
      }
      else{
        domain = window.location.hostname;
      }
      return `${window.location.protocol}//${newsubdomain}.${domain}:${window.location.port}?token=${userToken}`;
  }

  getSchoolAccountDashboardInfo(){
      return  this.http.get(this.rootUrl + `school/getschoolaccountinfo`);
  }

  
  async getStaticSchoolInfoBundle(){
    if(!this.schoolInfoBundlePromise){
      this.schoolInfoBundlePromise = this.getSchoolInfoBundle().toPromise();
    }
    const ret = await this.schoolInfoBundlePromise;
    return ret;
  }

  getSchoolInfoBundle(){
    const response = this.http.get<SchoolInfoBundle>(this.rootUrl + `School/getschoolconfig`);
    return response;
  }

  checkUserIsSubdomainAdmin(){
     return this.http.get<boolean>(this.rootUrl + `school/domainusercheck`);
  }

  checkTutorHasCourses(){
    return this.http.get<boolean>(`${this.rootUrl}modules/tutorhascourses`);
  }

  checkStudentHasCourses(){
    return this.http.get<boolean>(`${this.rootUrl}modules/studenthascourses`);
  }


  convertBytesToGB(bytes: number){
    //debugger;
    const gb = bytes / 1000000000;
    let ret = gb.toFixed(1);
    return ret;
  }

  numberWithCommas(x) {
    let xstring = x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    if(xstring.includes('.')){
      const xstringarray = xstring.split('.');
      xstringarray[1] = xstringarray[1].replaceAll(',', '');
      xstring = `${xstringarray[0]}.${xstringarray[1]}`;
    }

    return xstring;
  }

  confirm(title, description, isHtml: boolean = false){
    return this.dialog(title, description, true, isHtml);
  }

  alert(title, description, isHtml: boolean = false){
    return this.dialog(title, description, false, isHtml);
  }

  private dialog(title, description, confirmMode, isHtml){
    $('#appComponentConfirmModal_Title').text(title);
    if(isHtml){
      $('#appComponentConfirmModal_Body').html(description);
    }
    else{
      $('#appComponentConfirmModal_Body').text(description);
    }

    //debugger;
    this.dialogConfirmMode = confirmMode;
    $('#appComponentConfirmModal').modal('show');
    this.confirmPromise = new Promise<boolean>((resolve, reject) => {
      this.confirmPromiseResolve = resolve;
      //debugger;
    });
    return this.confirmPromise;
  }

  confirmYesClicked(){
    //debugger;
    this.confirmPromiseResolve(true);
  }

  confirmNoClicked(){
    this.confirmPromiseResolve(false);
  }

  getImpataBaseUrl(): string{
    const subdomainEndIndex = window.location.host.indexOf('.');
    const impataBaseUrl = window.location.host.substring(subdomainEndIndex + 1);
    return impataBaseUrl;
  }
  formatDate(date:Date){
    return this.datePipe.transform(date, 'yyyy-MM-dd hh:mm a');
  }

  logactivity(data: any){    
    var req_headers = new HttpHeaders({ "content-type": "application/json", "accept": "application/json" });
    return this.http.post(this.rootUrl + 'activity/logactivity', data, { headers: req_headers });
  }
  
  convertCustomDateStringToCalendarISODateFormatString(input: string): Date | string {    
    // Extract relevant parts of the string eg "Sat, 26 August 2023 / 12:25 pm" 
       
    const dateMatch = input.match(/(\d+)\s+(\w+)\s+(\d{4})/);
    const timeMatch = input.match(/(\d+:\d+)\s+(am|pm)/i);
    if (!dateMatch || !timeMatch) {
      console.log('Invalid input format');
      return input;
    }
  
    const day = +dateMatch[1];
    const monthName = dateMatch[2];
    const year = +dateMatch[3];
    let [hour, minute] = timeMatch[1].split(':').map(Number);
    const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    const month = monthNames.indexOf(monthName);
  
    if (timeMatch[2].toLowerCase() === 'pm' && hour !== 12) {
      hour += 12;
    }
    if (timeMatch[2].toLowerCase() === 'am' && hour === 12) {
      hour = 0;
    }
  
    const date = new Date(year, month, day, hour, minute);  
    const result = date.toISOString().split('.')[0];
  
    return result;
  }
  
  async hasFeature(featureGroup: number){
    return (await this.getStaticSchoolInfoBundle()).schoolConfig.plan.features.hasOwnProperty(featureGroup);
  }

  async getFeature(featureGroup: number){
    return (await this.getStaticSchoolInfoBundle()).schoolConfig.plan.features.hasOwnProperty(featureGroup) ? this.schoolInfoBundle.schoolConfig.plan.features[featureGroup] : null;
  }

  notifyFeatureNotAvailable(featureGroup: number){
    this.toastr.error(`Please upgrade your account to use this feature (${featureGroup})`);
  }
  getDeviceType():Device{
    const userAgent = window.navigator.userAgent;
    if (/Android/.test(userAgent)) {
      return Device.Android;
    } else if (/iOS|iPhone|iPad/.test(userAgent)) {
      return Device.IOS;
    } else {
      return Device.PC;
    }
  }

  mobile() {
    let check = false;
    const _window: any = window;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||_window.opera);
    return check;
  }
  isLink(data:any){
    let isLink = !data?.includes(' ') && data?.includes('.') && (data?.includes('http') || data?.includes('www'));
    if(isLink){
      return true;
    }
    return false;
  }
}

